
import qs from "qs";
import {Toast} from "vant";
import {vBeforeClose} from "@/utils/tool";

export default {
  data() {
    return {
      show1:false,
      timeShow:false,
      timeShow2:false,
      clientTaskInfos: [],
      id:1,
      clNo: '',
      checkboxData: [
        {value: true, label: this.$t('append_field.mon')},
        {value: true, label: this.$t('append_field.tue')},
        {value: true, label: this.$t('append_field.wed')},
        {value: true, label: this.$t('append_field.thu')},
        {value: true, label: this.$t('append_field.fri')},
        {value: true, label: this.$t('append_field.sat')},
        {value: true, label: this.$t('append_field.sun')}
      ],
      start_time: "",
      end_time: "",
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.clNo = this.$route.query.clNo
    this.getClientInfo()
    const tabbar = document.querySelector('.van-tabbar')
    tabbar.style.display = 'none'
    this.getDingshiInfo()
    document.title = this.$t('append_field.schedule_on_off')
  },
  methods: {
    vBeforeClose,
    onConfirm2(value){
      this.start_time = value
      this.timeShow2 = false
    },
    onConfirm(value){
      this.end_time = value
      this.timeShow = false
    },
    onEdit() {
      this.show1 = true
    },
    timeCancel(v){
      switch (v){
        case 0:
          this.timeShow = false
          break
        case 1:
          this.show1 = false
          this.end_time = ''
          this.start_time = ''
          break
        case 2:
          this.timeShow2 = false
          break
      }
      this.getDingshiInfo()
    },
    getDingshiInfo() {
      if (this.clientTaskInfos.length === 0) return
      this.start_time = this.clientTaskInfos[0].ttOnTime
      this.end_time =this.clientTaskInfos[0].ttOffTime
      this.checkboxData[0].value = this.clientTaskInfos[0].ttMon === "true"
      this.checkboxData[1].value = this.clientTaskInfos[0].ttTue === "true"
      this.checkboxData[2].value = this.clientTaskInfos[0].ttWed === "true"
      this.checkboxData[3].value = this.clientTaskInfos[0].ttThu === "true"
      this.checkboxData[4].value = this.clientTaskInfos[0].ttFri === "true"
      this.checkboxData[5].value = this.clientTaskInfos[0].ttSat === "true"
      this.checkboxData[6].value = this.clientTaskInfos[0].ttSun === "true"
    },
    setCheckbox(val) {
      let index = this.checkboxData.map(res => res.label).indexOf(val)
      this.checkboxData[index].value = !this.checkboxData[index].value

      this.$set(this.checkboxData, index, this.checkboxData[index])
      this.checkall = true

      for (let i = 0; i < this.checkboxData.length; i++) {
        if (!this.checkboxData[i].value) {
          this.checkall = false
          break
        }
      }
    },
    onDingshi() {
      if(!this.start_time||!this.end_time){
        Toast(this.$t('append_field.please_select_time'),'fail')
        return
      }
      // 检查是否至少选择了一个日期
      const isAnyDaySelected = this.checkboxData.some(day => day.value);
      if (!isAnyDaySelected) {
        Toast(this.$t('append_field.please_select_date'), 'fail');
        return;
      }
      this.$ajax.post("/etv/socket.json", {
        instruction: 5012,
        clientIdList: [this.id]
      }).then(res => {
        if (res.data.code === 0) {
          this.$ajax({
            url: "/etv/insertTimedTask.json",
            method: "post",

            data: {
              clientIdList:[this.id],
              timedTaskList: [
                {
                  ttMon: this.checkboxData[0].value,
                  ttTue: this.checkboxData[1].value,
                  ttWed: this.checkboxData[2].value,
                  ttThu: this.checkboxData[3].value,
                  ttFri: this.checkboxData[4].value,
                  ttSat: this.checkboxData[5].value,
                  ttSun: this.checkboxData[6].value,
                  ttOffTime: this.end_time,
                  ttOnTime: this.start_time,
                  ttState: true,
                  checkall: this.checkall,
                }
              ],

            }
          }).then(res => {
            if (res.data.code === 0) {
              Toast(res.data.msg)
              this.getClientInfo()
              this.getDingshiInfo()
            } else {
              Toast(res.data.msg)
            }
            this.show1 = false
          })
        }
      })
    },
    getClientInfo() {
      this.$ajax.post('/etv/selectClientByClId.json', qs.stringify({
        id: this.id,
      })).then(res => {
        if (res.data.code === 0) {
          this.clientTaskInfos = res.data.data.clientTaskInfo
          this.getDingshiInfo()
        }
      })

    },
    back() {
      this.$router.back()
    }
  }

}
